module.exports = __webpack_public_path__ + "static/media/logo.cb0a9182.png";